/* eslint-disable no-console */
import React, { Fragment } from 'react'

import Select from 'react-select'

import { Tooltip } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { func, shape, bool, string } from 'prop-types'

import CustomCheckbox from 'Pods/Shared/Checkbox/CustomCheckbox'
import Icon from 'Pods/Shared/Icon/Icon'
import InputField from 'Pods/Shared/InputField'

function CgiModelDetails({
  onDetailsChange: handleDetailChange,
  cgTechDetails = {
    unwrappedUVs: null,
    geometryType: null,
    polygons: 0,
    vertices: 0,
  },
  showErrors = false,
  errorFor,
}) {
  const details = [
    { title: 'Textures', slug: 'textures', hasSeparatorAfter: false },
    { title: 'Materials', slug: 'materials', hasSeparatorAfter: true },
    { title: 'Animated', slug: 'animated', hasSeparatorAfter: false },
    { title: 'Rigged', slug: 'rigged', hasSeparatorAfter: true },
    { title: 'Low-poly (game-ready)', slug: 'gameReady', hasSeparatorAfter: false },
    { title: 'PBR', slug: 'pbr', hasSeparatorAfter: true },
    { title: 'UVW mapping', slug: 'uvwMapping', hasSeparatorAfter: true },
    { title: 'Plugins used', slug: 'pluginsUsed', hasSeparatorAfter: false },
  ]

  const uvsOptions = I18n.translate('publisher.unwrapped_uvs')
  const geometryOptions = I18n.translate('publisher.geometry_types')
  const showTooltip = cgTechDetails.geometryType === 'gaussian_splats'

  if (!uvsOptions || !geometryOptions) {
    return null
  }

  return (
    <Fragment>
      <div className="technical-details-area__checkboxes">
        {details.map((detail, index) => (
          <Fragment key={detail.slug}>
            <CustomCheckbox
              text={detail.title}
              name={detail.slug}
              hasNoTransition
              customClass={!detail.hasSeparatorAfter && index !== details.length - 1 ? 'u-mr10' : ''}
              onTrigger={handleDetailChange}
              isChecked={cgTechDetails[detail.slug]}
            />
            {detail.hasSeparatorAfter && <span className="separator" />}
          </Fragment>
        ))}
      </div>

      <div className="row">
        <div className="col-12 col-md-6 col-lg-5 col-xl-4">
          <div className="row">
            <div className="col-6">
              <div className="section-heading--small u-mt10">Unwrapped UVs</div>
            </div>
            <div className="col-6">
              <div className="section-heading--small u-mt10">Geometry</div>
              {showTooltip && (
                <Tooltip
                  id="gaussian-splats-tooltip"
                  content={I18n.translate('tooltips.publisher.gaussian_splats')}
                  tooltipClassName="tooltip--normal-weight"
                >
                   <Icon type={['fas', 'info-circle']} color="grey" className="ml-5" />
                </Tooltip>
              )}
            </div>
            <div className="col-6">
              <Select
                id="unwrapped-uvs"
                className="Select-outline"
                placeholder="Choose value"
                options={uvsOptions}
                onChange={(data) => handleDetailChange('unwrappedUvs', data.value)}
                value={cgTechDetails.unwrappedUvs}
                searchable={false}
                clearable={false}
                disabled={!cgTechDetails.uvwMapping}
              />
              <span className="separator separator--absolute" />
            </div>
            <div className="col-6">
              <Select
                id="geometry-type"
                className="Select-outline"
                placeholder="Choose geometry"
                options={geometryOptions}
                onChange={(data) => handleDetailChange('geometryType', data.value)}
                value={cgTechDetails.geometryType}
                searchable={false}
                clearable={false}
              />
            </div>
          </div>
        </div>

        <div className="col-12 col-md-6 col-lg-5 col-xl-4">
          <div className="row polygons-and-vertices-inputs">
            <div className="col-6">
              <InputField
                label="Polygons"
                id="polygons"
                name="polygons"
                type="number"
                placeholder="0"
                value={cgTechDetails.polygons}
                formClassName="form-group-grey"
                inputClassName="form-control-grey"
                errorText={errorFor('polygons')}
                showError={showErrors}
                onChange={(e) => handleDetailChange(e.target.id, e.target.value)}
              />
            </div>
            <div className="col-6">
              <InputField
                label="Vertices"
                id="vertices"
                name="vertices"
                type="number"
                placeholder="0"
                value={cgTechDetails.vertices}
                formClassName="form-group-grey"
                inputClassName="form-control-grey"
                errorText={errorFor('vertices')}
                showError={showErrors}
                onChange={(e) => handleDetailChange(e.target.id, e.target.value)}
              />
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  )
}

CgiModelDetails.propTypes = {
  onDetailsChange: func.isRequired,
  cgTechDetails: shape({
    textures: bool.isRequired,
    materials: bool.isRequired,
    animated: bool.isRequired,
    rigged: bool.isRequired,
    gameReady: bool.isRequired,
    pbr: bool.isRequired,
    uvwMapping: bool.isRequired,
    pluginsUsed: bool.isRequired,
    unwrappedUvs: string,
    geometryType: string,
    polygons: string,
    vertices: string,
  }),
  showErrors: bool,
  errorFor: func.isRequired,
}

export default CgiModelDetails
